const FavoritesService = (function () {

    const createCustomWok = ($groupElement) => {
        const wokId = $groupElement.data('wok-id');
        let count = parseInt($($groupElement.find('.js_cwi_count')[0]).text());

        const getCount = () => {
            return count;
        };

        const inc = () => {
            count++;
            if (count === 1) {
                AnimationsService.animate.basket();
            }
            BasketService.addCustomWok(wokId, count);
            $groupElement.find('.js_cwi_count').text(count);
        };

        const dec = () => {
            count--;
            if (count < 0) {
                count = 0;
            }
            BasketService.addCustomWok(wokId, count);
            $groupElement.find('.js_cwi_count').text(count);
        };

        return {
            inc: inc,
            dec: dec,
            getCount: getCount
        };
    };

    const openAfterLoadPage = () => {
        const pathname = window.location.pathname;
        const urlEnd = pathname.substring(pathname.lastIndexOf("/") + 1);

        if (urlEnd !== AppService.tab.FAVORITES) {
            $(".js-extended-custom-wok-item[data-url='" + urlEnd + "']").click();
        }
    };

    const initToBasketBtn = ($groupElement, customWok) => {
        if (customWok.getCount() === 0) {
            $groupElement.find('.js_cwi_controls').hide();
            $groupElement.find('.js_cwi_to-basket-btn').show();
        } else {
            $groupElement.find('.js_cwi_to-basket-btn').hide();
            $groupElement.find('.js_cwi_controls').show();
        }
    };

    const deleteCustomWokFromFavorites = $groupElement => {
        const wokId = $groupElement.data('wok-id');

        const sushiUserFavouriteItemRequest = {
            woksIds: [wokId]
        };

        $.ajax({
            url: '/api/v5/sushi-user-favorite-item/delete',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(sushiUserFavouriteItemRequest)
        })
            .done(() => {
                $('.modal.in').modal('hide');
                document.getElementById(`${wokId}Anchor`).style.display = 'none';
            });
    };

    const setPathnameWithItemUrl = itemUrl => {
        const pathname = window.location.pathname;
        const urlEnd = pathname.substring(pathname.lastIndexOf("/") + 1);

        const newPathName = urlEnd === AppService.tab.FAVORITES ?
            `${pathname}/${itemUrl}` :
            `${pathname.substring(0, pathname.lastIndexOf("/"))}/${itemUrl}`;

        history.pushState({}, document.title, newPathName);
    };

    const init = () => {
        $('.js_custom-wok-item').filter(function () {
            const $groupElement = $(this);
            const customWok = createCustomWok($groupElement);

            $groupElement.find('.js_cwi_inc').click(() => {
                customWok.inc();
                initToBasketBtn($groupElement, customWok);
            });

            $groupElement.find('.js_cwi_dec').click(() => {
                customWok.dec();
                initToBasketBtn($groupElement, customWok);
            });

            $groupElement.find('.js_cwi_modal_inc').click(() => {
                customWok.inc();
                initToBasketBtn($groupElement, customWok);
            });

            $groupElement.find('.js_cwi_modal_dec').click(() => {
                customWok.dec();
                initToBasketBtn($groupElement, customWok);
            });

            $groupElement.find('.js_cwi_to-basket-btn').click(() => {
                $groupElement.find('.js_cwi_inc').trigger('click');
            });

            $groupElement.find('.js-extended-custom-wok-item').click(event => {
                if (
                    event.target.classList.length > 0 &&
                    !event.target.classList.contains('js_cwi_inc') &&
                    !event.target.classList.contains('js_cwi_dec') &&
                    !event.target.classList.contains('js_cwi_count') &&
                    !event.target.classList.contains('js_cwi_controls') &&
                    !event.target.classList.contains('js_cwi_to-basket-btn')
                ) {
                    $('#' + $groupElement.data('wok-id')).modal('show');
                    setPathnameWithItemUrl($groupElement.data('url'));
                }
            });

            $groupElement.find('.js_sc_favorites').click(() => {
                deleteCustomWokFromFavorites($groupElement);
            });

            initToBasketBtn($groupElement, customWok);
        });

        openAfterLoadPage();
    };

    return {
        init: init
    }
})();

$(FavoritesService.init);
